export default {
  async 'tenures-list'(config = {}) {
    return await this.$get({
      url: `${this.$baseurl}/invest/tenures/`,
      headers: this.headers,
      ...config,
    });
  },
};
